export class ProviderPopupClosedError extends Error {
	constructor() {
		super('SignIn provider popup has been closed by the user');
		this.name = 'SignInProviderPopupClosed';
	}
}
